import { SVGFC } from '@repo/toolkit/types'

const EmailIcon: SVGFC = ({ color, ...props }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M4.58919 5.51928L8.56216 3.36427C9.0039 3.12518 9.49801 3 10 3C10.502 3 10.9961 3.12518 11.4378 3.36427L15.4108 5.51928C15.8902 5.77875 16.2909 6.16314 16.5706 6.6319C16.8503 7.10066 16.9986 7.63643 17 8.18268V13.9648C17 14.7698 16.6811 15.5418 16.1134 16.111C15.5457 16.6802 14.7758 17 13.973 17H6.02703C5.22421 17 4.45427 16.6802 3.8866 16.111C3.31892 15.5418 3 14.7698 3 13.9648V8.18268C3.00136 7.63643 3.14971 7.10066 3.42941 6.6319C3.70911 6.16314 4.10979 5.77875 4.58919 5.51928Z"
        stroke={color}
        strokeWidth="1.225"
      />
      <path
        d="M3.12061 7.33984L8.48601 10.4509C8.94618 10.7173 9.46817 10.8576 9.99952 10.8576C10.5309 10.8576 11.0529 10.7173 11.513 10.4509L16.9163 7.41572"
        stroke={color}
        strokeWidth="1.225"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default EmailIcon
